module.exports = __webpack_public_path__ + "Leo_Sarria_Web_Over.jpg?a7b156fb2dd52939876289d06b7bd405";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Leo_Sarria_Web_Over.jpg
// module id = 180
// module chunks = 0